module.exports = __webpack_public_path__ + "img/animalsaustralia.72345db.png";